"use strict";

import { lcvParticipantsConstants } from "../_constants/lcvParticipants.constants";

export const INITIAL_LCV_PARTICIPANTS_STATE = {
     jobRoles : [],
     importResult : null,
     importHistory : { items: [], totalCount: 0 },
};

export function lcvParticipants(state = INITIAL_LCV_PARTICIPANTS_STATE, action) {
    switch (action.type) {
     // The BFF unwraps the gateway envelope, so the payload is already the bare result.
     case lcvParticipantsConstants.LCV_PARTICIPANTS_GET_JOB_ROLES_COMPLETE:
          return {
               ...state,
               jobRoles: action.payload || [],
          };
     case lcvParticipantsConstants.LCV_PARTICIPANTS_IMPORT_COMPLETE:
          return {
               ...state,
               importResult: action.payload || null,
          };
     case lcvParticipantsConstants.LCV_PARTICIPANTS_CLEAR_IMPORT_RESULT:
          return {
               ...state,
               importResult: null,
          };
     case lcvParticipantsConstants.LCV_PARTICIPANTS_GET_IMPORT_HISTORY_COMPLETE:
          return {
               ...state,
               importHistory: action.payload || { items: [], totalCount: 0 },
          };
     default:
          return state;
    }
}
